/** @module Apparel/PrintDesign/CopyPrintDesign */
define([
	"dojo/_base/declare",
	"csi/table/Copy"
], function(declare,Copy) {
	
	return declare(Copy, {
		PRINT_POSITIONS_COUNT: "PrintPositionsCount",
		/**
		 * @override
		 * @param {Widget} view
		 * Disabled the PrintPositionsCount field
		 */
		onCreatePopup: function(/*csi.view.Widget*/view) {
			view.setFieldDisabled(this.PRINT_POSITIONS_COUNT, true);
			this.inherited(arguments);
		}
	});
});
